export function $getThemeName(themeName) {
  return themeName;
}